const initialState = {
  page: {},
  analysisParam: {},
  trendAnalysis: {},
  selectedModuleAndRouteDetails: {},
  schemes: {},
  summaryDashboard: {},
  misReport: {},
  rewardReport: {},
  monthlySummary: {},
  financialYearReport: {},
  kycUpdationReports: {},
  downloadReports: {},
  downloadDumpSwitchIsReport: false,
  customeDateFilterActive: [{
    CustomeDate: null,
    ComparedDate: null
  }]
};

const reportPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "GET_TYPE_PAGE":
      return {
        ...state,
        page: payload,
      };
    case "GET_SUMMARY_ANALYSIS":
      return {
        ...state,
        analysisParam: payload,
      };
    case "TREND_ANALYSIS":
      return {
        ...state,
        trendAnalysis: payload,
      };
    case "SELECTED_MODULE_AND_ROUTE_DETAILS":
      return {
        ...state,
        selectedModuleAndRouteDetails: payload,
      };
    case "Schemes_Report":
      return {
        ...state,
        schemes: payload,
      };
    case "SUMMARY_DASHBOARD":
      return {
        ...state,
        summaryDashboard: payload,
      };
    case "MIS_REPORT":
      return {
        ...state,
        misReport: payload,
      };
    case "REWARD_REPORT":
      return {
        ...state,
        rewardReport: payload,
      };
    case "MONTHLY_SUMMARY":
      return {
        ...state,
        monthlySummary: payload,
      };
    case "FINANCIAL_YEAR_REPORT":
      return {
        ...state,
        financialYearReport: payload,
      };
    case "KYC_UPDATION_REPORTS":
      return {
        ...state,
        kycUpdationReports: payload,
      };
    case "DOWNLOAD_REPORTS":
      return {
        ...state,
        downloadReports: payload,
      };
    case `CLEAR_FILTER`:
      const updatedState = { ...state };
      switch (payload) {
        case "startDate":
          updatedState.schemes.isoSd = ""
          updatedState.schemes.isoEd = ""
          break

        case "selectedMasterScheme":
          updatedState.schemes.selectedSchemeDetails.selectedMasterScheme = null
          updatedState.schemes.selectedSchemeDetails.selectedSubScheme = []
          break
        case "selectedSubScheme":
          updatedState.schemes.selectedSchemeDetails.selectedSubScheme = []
          updatedState.schemes.selectedSchemeDetails.subSchemesList =
            updatedState.schemes.selectedSchemeDetails.subSchemesList.map(
              (item) =>
                item.value === ""
                  ? { ...item, label: "Select All" } // Reset "Select All" label
                  : item
            )


          break;
        case "selectedNormalStatusForScheme":
          updatedState.schemes.selectedSchemeDetails.selectedNormalStatusForScheme =
            null
          updatedState.schemes.selectedSchemeDetails.normalStatusForSchemeList =
            updatedState.schemes.selectedSchemeDetails.normalStatusForSchemeList.map(
              (item) =>
                item.value === ""
                  ? { ...item, label: "Select All" } // Reset "Select All" label
                  : item
            )
          break
        case "selectedPassbookBalanceStatus":
          updatedState.schemes.selectedSchemeDetails.selectedPassbookBalanceStatus =
            null
          break
        case "selectedCollectionType":
          updatedState.schemes.selectedSchemeDetails.selectedCollectionType =
            null
          break
        case "selectedReceiptType":
          updatedState.schemes.selectedSchemeDetails.selectedReceiptType = null
          break
        case "mobileNo":
          updatedState.schemes.selectedSchemeDetails.mobileNo = null
          break
        case "passbookNo":
          updatedState.schemes.selectedSchemeDetails.passbookNo = null
          break
        default:
          break
      }
      return updatedState;

    case `CLEAR_MISREPORT_FILTER`:
      const updatedMisReportState = { ...state };
      switch (payload) {
        case "startDate":
          updatedMisReportState.misReport.isoSd = "";
          updatedMisReportState.misReport.isoEd = "";
          break;

        case "selectedSubScheme":
          updatedMisReportState.misReport.selectedSchemeDetails.selectedSubScheme =
            [];
          break;
        case "selectedStatus":
          updatedMisReportState.misReport.selectedSchemeDetails.selectedStatus =
            null;
          break;

        default:
          break;
      }
      return updatedMisReportState;

    case `CLEAR_SUMMARYDASHBOARD_FILTER`:
      const updatedSummaryDashboard = { ...state };
      switch (payload) {
        case "startDate":
          updatedSummaryDashboard.summaryDashboard.isoSd = "";
          updatedSummaryDashboard.summaryDashboard.isoEd = "";
          break;

        default:
          break;
      }
      return updatedSummaryDashboard;

    case `CLEAR_MONTHLYSUMMARY_DETAILS`:
      const updatedMonthlySummary = { ...state };
      switch (payload) {
        case "startDate":
          updatedMonthlySummary.monthlySummary.isoSd = "";
          updatedMonthlySummary.monthlySummary.isoEd = "";

          break;

        default:
          break;
      }
      return updatedMonthlySummary;
    case `CLEAR_FINANTIAL_DETAILS`:
      const updatedMFinantial = { ...state };
      switch (payload) {
        case "startDate":
          updatedMFinantial.financialYearReport.isoSd = "";
          updatedMFinantial.financialYearReport.isoEd = "";

          break;

        default:
          break;
      }
      return updatedMFinantial;

    case `CLEAR_REWARDREPORT_DETAILS`:
      const updatedRewardReport = { ...state };
      switch (payload) {
        case "startDate":
          updatedRewardReport.rewardReport.isoSd = "";
          updatedRewardReport.rewardReport.isoEd = "";

          break;

        default:
          break;
      }
      return updatedRewardReport;
    case `CLEAR_DOWNLOAD`:
      const updatedDownload = { ...state };
      switch (payload) {
        case "startDate":
          updatedDownload.downloadReports.isoSd = "";
          updatedDownload.downloadReports.isoEd = "";
          break;

        default:
          break;
      }
      return updatedDownload;

    case `CLEAR_KYC_FILTER`:
      const updatedKycState = { ...state };
      switch (payload) {
        case "startDate":
          updatedKycState.kycUpdationReports.isoSd = "";
          updatedKycState.kycUpdationReports.isoEd = "";
          break;
        case "sourceType":
          updatedKycState.kycUpdationReports.selectedSchemeDetails.selectedSource =
            null;
          break;

        case "approvedBy":
          updatedKycState.kycUpdationReports.selectedSchemeDetails.approvedBy =
            null;
          break;
        case "selectedSchemeType":
          updatedKycState.kycUpdationReports.selectedSchemeDetails.selectedSchemeType =
            null;
          updatedKycState.kycUpdationReports.selectedSchemeDetails.schemeType =
            null;
          break;
        default:
          break;
      }
      return updatedKycState;

    // Generic case to handle updating fields in selectedSchemeDetails
    case "UPDATE_SCHEME_DETAIL_FIELD": {
      const { field, value } = payload; // Destructure field and value from the payload
      return {
        ...state,
        schemes: {
          ...state.schemes,
          selectedSchemeDetails: {
            ...state.schemes.selectedSchemeDetails,
            [field]: value, // Dynamically update the field
          },
        },
      };
    }

    case "ADD_MOBILE_NO": {
      const { mobileNo, selectedNavigation } = payload;
      return {
        ...state,
        schemes: {
          ...state.schemes,
          selectedSchemeDetails: {
            ...state.schemes.selectedSchemeDetails,
            mobileNo, // Update mobileNo with the value from the payload
          },
          selectedNestedSubModule: {
            ...state.schemes.selectedNestedSubModule,
            ...selectedNavigation, // Update selectedNestedSubModule with selectedNavigation
          },
        },
      };
    }

    case "ADD_PASSBOOK_NO": {
      const { passbookNo, selectedNavigation } = payload;
      return {
        ...state,
        schemes: {
          ...state.schemes,
          selectedSchemeDetails: {
            ...state.schemes.selectedSchemeDetails,
            passbookNo, // Update passbookNo with the value from the payload
          },
          selectedNestedSubModule: {
            ...state.schemes.selectedNestedSubModule,
            ...selectedNavigation, // Update selectedNestedSubModule with selectedNavigation
          },
        },
      };
    }

    case "UPDATE_SCHEME_DETAILS":
      const { schemeDetails, schemesDatePayload } = payload;

      return {
        ...state,
        schemes: {
          ...state.schemes,
          selectedSchemeDetails: schemeDetails,
          isoSd: new Date(schemesDatePayload?.startDate),
          isoEd: new Date(schemesDatePayload?.endDate),
        },
      };
    case "UPDATE_MIS_DETAILS":
      const { misDetailes, misdatePayload } = payload;

      return {
        ...state,
        misReport: {
          ...state.misReport,
          selectedSchemeDetails: misDetailes,
          isoSd: misdatePayload?.startDate,
          isoEd: misdatePayload?.endDate,
        },
      };
    case "UPDATE_SUMMARYDASHBOARD_DETAILS":
      const { summaryDashboard, summarydashboarddatePayload } = payload;

      return {
        ...state,
        summaryDashboard: {
          ...state.summaryDashboard,
          selectedSchemeDetails: summaryDashboard,
          isoSd: summarydashboarddatePayload?.startDate,
          isoEd: summarydashboarddatePayload?.endDate,
        },
      };
    case "UPDATE_MONTHLYSUMMARY_DETAILS":
      const { monthlySummary, monthlySummarydatePayload, id } = payload;


      // Define the base monthly summary object
      const updatedMonthlySummaryFor504 = {
        ...state.monthlySummary,
        selectedSchemeDetails: monthlySummary,
        isoSd: monthlySummarydatePayload?.startDate,
        isoEd: monthlySummarydatePayload?.endDate,
      };

      // Conditionally add month and year if id === 504
      if (id === "504") {

        // Extract month and year from the payload
        const selectedMonth = monthlySummarydatePayload?.month
          ? new Date(monthlySummarydatePayload.month).getMonth() + 1
          : null;

        const selectedYear = monthlySummarydatePayload?.month
          ? new Date(monthlySummarydatePayload.month).getFullYear()
          : new Date().getFullYear();

        if (monthlySummarydatePayload?.month) {
          // Set start date as the first day of the month
          updatedMonthlySummaryFor504.isoSd = `${selectedYear}-${selectedMonth
            .toString()
            .padStart(2, "0")}-01`;

          // Get the last day of the month dynamically
          const lastDay = new Date(selectedYear, selectedMonth, 0).getDate();
          updatedMonthlySummaryFor504.isoEd = `${selectedYear}-${selectedMonth
            .toString()
            .padStart(2, "0")}-${lastDay}`;

          updatedMonthlySummaryFor504.month = selectedMonth;
          updatedMonthlySummaryFor504.year = null;
        } else {
          const selectedYear_ = monthlySummarydatePayload?.year
            ? new Date(monthlySummarydatePayload.year).getFullYear()
            : new Date().getFullYear();
          // Default to full year if no specific month is provided
          updatedMonthlySummaryFor504.isoSd = `${selectedYear_}-01-01`;
          updatedMonthlySummaryFor504.isoEd = `${selectedYear_}-12-31`;
          updatedMonthlySummaryFor504.month = null;
          updatedMonthlySummaryFor504.year = 1;
        }

      }

      return {
        ...state,
        monthlySummary: updatedMonthlySummaryFor504,
      };

    case "UPDATE_FINANTIAL_DETAILS":
      const { finantial, finantiadatePayload } = payload;

      return {
        ...state,
        financialYearReport: {
          ...state.financialYearReport,
          selectedSchemeDetails: finantial,
          isoSd: finantiadatePayload?.startDate,
          isoEd: finantiadatePayload?.endDate,
        },
      };
    case "UPDATE_REWARDREPORT_DETAILS":
      const { rewardReport, rewardReportDatesPayload } = payload;

      return {
        ...state,
        rewardReport: {
          ...state.rewardReport,
          selectedSchemeDetails: rewardReport,
          isoSd: rewardReportDatesPayload?.startDate,
          isoEd: rewardReportDatesPayload?.endDate,
        },
      };
    case "UPDATE_KYCREPORT_DETAILS":
      const { kycReport, kycReportDatesPayload } = payload;

      return {
        ...state,
        kycUpdationReports: {
          ...state.kycUpdationReports,
          selectedSchemeDetails: kycReport,
          isoSd: kycReportDatesPayload?.startDate,
          isoEd: kycReportDatesPayload?.endDate,
        },
      };
    case "SWITCHFILTER":


      return {
        ...state,
        downloadDumpSwitchIsReport: payload

      };
    case "ACTIVECUSTOMEDATE":
      return {
        ...state,
        customeDateFilterActive: payload.CustomeDate === null && payload.ComparedDate === null
          ? { CustomeDate: null, ComparedDate: null }  // Reset both values completely
          : { ...state.customeDateFilterActive, ...payload } // Otherwise, update specific fields
      }
    case "CLEAR_SHEDULEREPORT_FILTER":
      const updateSheduleReport = { ...state };
      switch (payload) {
        case "startDate":
          updateSheduleReport.scheduleReport.isoSd = "";
          updateSheduleReport.scheduleReport.isoEd = "";
          break;

        default:
          break;
      }
      return updateSheduleReport;


    case "UPDATE_SCHEDULEREPORTS":
      const { schedule, schedeleDatesPayload } = payload;

      return {
        ...state,
        scheduleReport: {
          ...state.scheduleReport,
          selectedSchemeDetails: schedule,
          isoSd: schedeleDatesPayload?.startDate,
          isoEd: schedeleDatesPayload?.endDate,
        },
      };

    case "SCHEDULE_REPORTS":
      return {
        ...state,
        scheduleReport: payload,
      };



    default:
      return state;
  }
};

export default reportPageReducer;
